<template>
  <div v-if="this.getUser.pref.select.cdid !== null && this.getUser.pref.select.cdid !== ''">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
    v-if="this.data.btnSize === 'flat'">
      <v-icon left>
        add
      </v-icon>
      {{data.btnTitle}}
    </v-btn>
    <v-btn :color="ui.bkgdColor" icon @click="openDialog()"
    v-else>
      <v-icon :color="ui.btnColor">
        add
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Incident
              </div>
            </span>
            <v-spacer/>
            <v-icon :color="ui.btnColor"
            v-if="this.eventTitlePrefix === 'Facility'"> place </v-icon>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{eventTitlePrefix}} {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <div v-if="this.incidentAsset.id !== null && this.incidentAsset.id !== ''">
                <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon :color="ui.colorWarning"> emoji_transportation </v-icon>
                    </v-avatar>
                    <div :class="ui.textWarning">
                      Asset
                    </div>
                  </v-chip>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2 mt-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="incidentAsset.title"
                    prepend-icon="title"
                    hint="asset name"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="incidentAsset.id"
                    prepend-icon="fingerprint"
                    hint="asset tag"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="incident title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.found"
                    :items="asFoundConditionOptions"
                    color="wplblue0"
                    prepend-icon="local_fire_department"
                    hint="as found condition"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-1 mr-1">
                <v-flex xs12>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="incident description"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="describe what happened"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  Company
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.cname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_balance </v-icon>
                  </v-avatar>
                  {{getUser.pref.select.cname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.getUser.pref.select.fdid !== ''">
                  {{getUser.pref.select.fname}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-else>
                  Not Selected
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                    <v-icon> place </v-icon>
                  </v-avatar>
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <div v-if="
                this.getDetailBasic !== null &&
                getUser.pref.select.fname !== null &&
                getUser.pref.select.fname !== '' &&
                this.getDetailBasic.tag === 'A1'
                "
                >
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                    </v-avatar>
                    Asset Name
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{incidentAsset.title}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                    </v-avatar>
                    {{incidentAsset.title}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> fingerprint </v-icon>
                    </v-avatar>
                    Asset Tag
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{this.getDetailBasic.id}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> fingerprint </v-icon>
                    </v-avatar>
                    {{this.getDetailBasic.id}}
                  </v-chip>
                </v-layout>
              </div>

              <!-- <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                  </v-avatar>
                  {{this.getDetailBasic.title}}
                </v-chip>
              </v-layout> -->
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> report </v-icon>
                  </v-avatar>
                  Incident
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> title </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <!-- <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{localForm.tag}}
                </v-chip>
              </v-layout> -->
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> local_fire_department </v-icon>
                  </v-avatar>
                  As Found
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.found}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                    <v-icon> local_fire_department </v-icon>
                  </v-avatar>
                  {{localForm.found}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          class="hidden-xs-only"
          @click="nextStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_next </v-icon>
            Next
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up">
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          class="hidden-xs-only"
          v-if="enableSubmit"
          @click="createNewIncident()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          @click="createNewIncident()" :color="ui.colorWarning" flat
          class="hidden-sm-and-up">
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import eventOptions from "@/data/options/mixins/eventOptions.js";
import moment from "moment";
import generateRoles from "@/support/roles/mixins/generateRoles.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    facilityOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    transFunctions,
    riskOptions,
    generateRoles,
    eventOptions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        tag: "",
        des: "",
        found: ""
      },
      info: [
        {
          step: 0,
          title: "Incident Event",
          // eslint-disable-next-line
          msg: "An undesirable consequence of planned or unplanned action completed by human or machine. Report all incidents to prevent repeat of the event and to learn from past incidents.",
          icon: ""
        },
        {
          step: 1,
          title: "Incident Event Title",
          // eslint-disable-next-line
          msg: "Select appropriate as found condition at the time of Incident Event. Ensure that as found condition is made safe and any active stored energy sources are isolated (if applicable).",
          icon: ""
        },
        {
          step: 2,
          title: "Event time, date and sequence of events",
          // eslint-disable-next-line
          msg: "Describe what happened prior to the incident, what was experienced during the incident and immediate consequence of the incident. Provide detail of immediate response, time, date, evidence, what was unusual or unexpected as the event was developing.",
          error: "",
          icon: ""
        },
        {
          step: 3,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. Please return to previous steps if required.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser", "getCompany"]),
    incidentAsset() {
      let obj = {
        title: "",
        id: ""
      };
      if (this.data.info !== undefined && this.data.info !== null) {
        obj.title = this.data.info.basic.title;
        obj.id = this.data.info.basic.id;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic.tag === "A1"
      ) {
        obj.title = this.getDetailBasic.title;
        obj.id = this.getDetailBasic.id;
      } else if (this.getDetailLink !== null && this.getDetailLink !== null) {
        if (this.getDetailLink.at !== "") {
          obj.title = this.getDetailLink.at;
          obj.id = this.getDetailLink.aid;
        }
      } else {
        if (this.getDetailBasic !== null && this.getDetailBasic !== undefined) {
          if (this.getDetailBasic.tag === "A1") {
            obj.title = this.getDetailBasic.title;
            obj.id = this.getDetailBasic.id;
          }
        }
      }
      return obj;
    },
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (
        this.step === 3 &&
        this.getCompanyDID !== null &&
        this.btnSpinChangeDetail === false
      ) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (this.step == 1 && this.localForm.name !== "") {
        logic = true;
      } else if (this.step == 2 && this.localForm.des) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    eventTitlePrefix() {
      let title = null;
      if (this.getCurrentPage === "/facilitydashoperations") {
        title = "Facility";
      } else if (this.getCurrentPage === "/assetdetail") {
        title = "Facility";
      } else if (this.getCurrentPage === "/companydashsafety") {
        title = "Company";
      } else if (this.getRegisterInfo !== null) {
        if (this.getRegisterInfo.tag === "F1") {
          title = "Facility";
        } else {
          title = "Facility";
        }
      } else {
        title = "Company";
      }
      return title;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewIncident() {
      // this.btnSpinChangeDetail = true;

      // SET data source
      const tag = "S6";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateIncidentForm();

      // BASIC data
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = true; // set asset to true
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.tag;

      // CHAR data
      temp.char.des = this.localForm.des;
      temp.char.found = this.localForm.found;
      temp.char.cat = "Minor";
      temp.char.cond = "Operations";
      temp.char.reach = "Asset";
      temp.char.spons = "Management";
      temp.char.inde = "Facility";
      temp.char.dis = "General";
      // LINK DATA FACILITY
      if (
        this.getUser.pref.select.fdid !== "" &&
        this.getUser.pref.select.fdid !== undefined &&
        this.getUser.pref.select.fdid !== null &&
        this.getUser.pref.select.fauth !== undefined &&
        this.getUser.pref.select.fauth !== null
      ) {
        temp.link.fid = this.getUser.pref.select.fdid;
        temp.link.ft = this.getUser.pref.select.fname;
        temp.link.fid = this.getUser.pref.select.fname;
      }
      // LINK DATA
      if (
        this.getDetailBasic !== null &&
        this.getDetailBasic !== undefined &&
        this.getDetailBasic.tag === "A1"
      ) {
        temp.link.adid = this.getDetailBasic.did;
        temp.link.aid = this.getDetailBasic.id;
        temp.link.aidg = this.getDetailBasic.idg;
        temp.link.at = this.getDetailBasic.title;
        temp.link.atag = this.getDetailBasic.tag;
      }
      // STATS data
      temp.stats.dcrt = moment().format();
      temp.stats.devent = moment().format();

      // REV data
      temp.rev = this.generateInitialDocumentRev(tag);

      // TRANS
      let trans = this.generateInitalTransition(tag); // model
      temp.trans = trans;

      // Only select Facility if Parent is alos Facility select
      if (this.eventTitlePrefix === "Facility") {
        let select = this.getUser.pref.select;
        temp.link.fdid = select.fdid;
        temp.link.ft = select.fname;
        temp.link.fid = select.fid;
        temp.link.fidg = select.fidg;
      }

      // CREATE DOC.
      this.createFirebaseDocumentOnly(temp);
    }
  }
};
</script>
